import initialState from '../store/initial-state'
import { ASSET_RIGHTS_STATE_UPDATED } from '../constants/rights-constants'
import {
  ASSET_EXPLORE_GET_DATA,
  ASSET_EXPLORE_GET_DATA_SUCCESS,
  ASSET_EXPLORE_GET_DATA_FAILURE,
  ASSET_EXPLORE_EMPTY,
  ASSET_EXPLORE_ADD,
  ASSET_EXPLORE_ACTIVEVIEW,
  ASSET_EXPLORE_EDIT,
  ASSET_EXPLORE_EDIT_SUCCESS,
  ASSET_EXPLORE_EDIT_FAILURE,
  ASSET_EXPLORE_SET_SELECT,
  ASSET_EXPLORE_UNSET_SELECT,
  ASSET_EXPLORE_DELETE,
  ASSET_EXPLORE_DELETE_SUCCESS,
  ASSET_EXPLORE_DELETE_FAILURE,
  ASSET_EXPLORE_EDIT_SELECT,
  ASSET_EXPLORE_EDIT_UNSET_SELECT,
  ASSET_EXPLORE_EXPAND_SELECT,
  ASSET_EXPLORE_EXPAND_UNSET_SELECT,
  ASSET_EXPLORE_SHARE_SELECT,
  ASSET_EXPLORE_SHARE_UNSET_SELECT,
  ASSET_EXPLORE_MOVE,
  ASSET_EXPLORE_MOVE_SUCCESS,
  ASSET_EXPLORE_MOVE_FAILURE,
  ASSET_EXPLORE_CHECK_SELECT,
  ASSET_EXPLORE_UNCHECK_SELECT,
  MULTIPLE_EXPLORE_OPTIONS_ACTIVATE,
  MULTIPLE_EXPLORE_OPTIONS_DEACTIVATE,
  MULTIPLE_EXPLORE_OPTIONS_DONE,
  ASSET_EXPLORE_UPDATE_FROM_PERMISSION,
  ASSETS_EXPLORE_MULTI_DELETE,
  ASSETS_EXPLORE_MULTI_DELETE_SUCCESS,
  ASSETS_EXPLORE_MULTI_DELETE_FAILURE,
  ASSETS_EXPLORE_MULTI_MOVE,
  ASSETS_EXPLORE_MULTI_MOVE_SUCCESS,
  ASSETS_EXPLORE_MULTI_MOVE_FAILURE,
  CLEAN_DATA_BACK_EXPLORE,
  SCROLL_EXPLORE,
} from '../constants/assets-explore-types'

export default (state = initialState.assetsExplore, action) => {
  switch (action.type) {
    case ASSET_EXPLORE_GET_DATA:
      return {
        ...state,
        folderselect: action.payload.folder,
        isFetching: action.payload.isFetching,
        data: action.payload.data,
        isLoadingScroll: action.payload.isLoadingScroll,
        // folderselect: action.payload,
        // isFetching: true,
        // data: [],
        error: null
      }

    case ASSET_EXPLORE_GET_DATA_SUCCESS:
      const pageScroll = action.payload.page
      return {
        ...state,
        isFetching: false,
        data: action.payload.user.clientRole === 'admin' || action.payload.user.role === 'admin'
          ? pageScroll !== 1 ? [...state.data, ...action.payload.data] : action.payload.data
          : pageScroll !== 1 ? [...state.data, ...action.payload.data.filter(r => r.group.length > 0 || r.isShared)] : action.payload.data.filter(r => r.group.length > 0 || r.isShared),
        headers: action.payload.headers,
        // page: action.payload.page,
        // limit: action.payload.limit,
        orderBy: action.payload.orderBy,
        tagProtocol: action.payload.tagProtocol,
        longDescription: action.payload.longDescription,
        error: null,
        showScrolling:  false,
        isLoadingScroll: false
      }

    case ASSET_EXPLORE_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: [],
        error: action.payload,
        showScrolling:  false,
      }

    case ASSET_EXPLORE_EMPTY:
      return {
        ...state,
        folderselect: null,
        isFetching: true,
        data: [],
        headers: [],
        error: null
      }

    case ASSET_EXPLORE_ADD:
      return {
        ...state,
        data: state.folderselect === action.payload.folderselect
          ? [{
            _id: action.payload.data._id,
            type: action.payload.data.type,
            name: action.payload.data.name,
            lowQualityURL: action.payload.data.lowQualityURL,
            mediaQualityURL: action.payload.data.mediaQualityURL,
            originalURL: action.payload.data.originalURL,
            metadata: action.payload.data.metadata
          },
          ...state.data]
          : state.data
      }

    case ASSET_EXPLORE_SET_SELECT:
      const maxItems = action.payload.from === 'vertical'
        ? action.payload.verticalCount
        : action.payload.horizontalCount
      let exist = false
      let count = 0

      return {
        ...state,
        data: [...state.data.map((r, k) => {
          let i = k + 1
          if (count >= maxItems) {
            count = 1
            exist = false
          } else {
            count++
          }
          if (!exist) exist = `${action.payload.from}-${i}` === action.payload.indice
          return {
            ...r,
            drawMiddleView: (exist && maxItems === count) || (exist && i === state.data.length),
            isSelected: r._id === action.payload.data._id,
            indice: r._id === action.payload.data._id
              ? action.payload.indice
              : '',
            from: r._id === action.payload.data._id
              ? action.payload.from
              : null
          }
        })]
      }

    case ASSET_EXPLORE_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            drawMiddleView: false,
            isSelected: false,
            indice: '',
            from: null
          }
        })]
      }

    case ASSET_EXPLORE_ACTIVEVIEW:
      return {
        ...state,
        activeView: action.payload.activeView
      }

    case ASSET_EXPLORE_EDIT:
      return {
        ...state,
        isUpdating: true,
        error: null
      }

    case ASSET_EXPLORE_EDIT_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        data: [...state.data.map(r => {
          return {
            ...r,
            indice: r._id === action.payload.data._id
              ? action.payload.indice
              : null,
            from: r._id === action.payload.data._id
              ? action.payload.from
              : null,
            name: r._id === action.payload.data._id
              ? action.payload.data.name
              : r.name,
            metadata: {
              ...r.metadata,
              descriptiveTags: r._id === action.payload.data._id
                ? action.payload.data.metadata.descriptiveTags
                : r.metadata && r.metadata.descriptiveTags ? r.metadata.descriptiveTags : [],
              createdDate: r._id === action.payload.data._id
                ? action.payload.data.metadata.createDate
                : r.metadata && r.metadata.createDate ? r.metadata.createDate : null,
              dueDate: r._id === action.payload.data._id
                ? action.payload.data.metadata.dueDate
                : r.metadata && r.metadata.dueDate ? r.metadata.dueDate : null,
            }
          }
        })]
      }

    case ASSET_RIGHTS_STATE_UPDATED: {
      const hasAsset = state.data.some(r => r._id === action.payload.assetId)
      if (!hasAsset) return state
      return {
        ...state,
        data: state.data.map(r =>
          r._id === action.payload.assetId
            ? {
                ...r,
                rightsState: action.payload.rightsState,
                metadata: {
                  ...r.metadata,
                  rightsStatus: action.payload.rightsStatus,
                  dueDate: action.payload.dueDate,
                  createdDate: action.payload.createdDate,
                  // El contrato y la hora de asignación también: la bitácora se
                  // refresca con ellos cuando lo único que cambió fue el contrato.
                  licenseFile: action.payload.licenseFile,
                  rightsAssignedAt: action.payload.rightsAssignedAt
                }
              }
            : r
        )
      }
    }

    case ASSET_EXPLORE_EDIT_FAILURE:
      return {
        ...state,
        isUpdating: false,
        headers: null,
        error: action.payload
      }

    case ASSET_EXPLORE_EDIT_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isEditSelected: r._id === action.payload.data._id,
          }
        })],
        editAssetTab: action.payload.editAssetTab
      }

    case ASSET_EXPLORE_EDIT_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isEditSelected: false,
          }
        })]
      }

    case ASSET_EXPLORE_EXPAND_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isExpandSelected: r._id === action.payload.data._id,
          }
        })]
      }

    case ASSET_EXPLORE_EXPAND_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isExpandSelected: false,
          }
        })]
      }

    case ASSET_EXPLORE_DELETE:
      return {
        ...state,
        isFetching: true
      }

    case ASSET_EXPLORE_DELETE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        workclient: action.payload.workclient,
        data: [...state.data.filter(r => r._id !== action.payload.id)],
        error: null
      }

    case ASSET_EXPLORE_DELETE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload.error
      }

    case ASSET_EXPLORE_SHARE_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isShareSelected: r._id === action.payload.data._id,
          }
        })]
      }

    case ASSET_EXPLORE_SHARE_UNSET_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isShareSelected: false,
          }
        })]
      }

    case ASSET_EXPLORE_MOVE:
      return {
        ...state,
        isMoving: true,
        headers: null,
        error: null
      }

    case ASSET_EXPLORE_MOVE_SUCCESS:
      return {
        ...state,
        isMoving: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            isMoveSelected: false,
            isMoved: r._id === action.payload.data._id,
          }
        })]
      }

    case ASSET_EXPLORE_MOVE_FAILURE:
      return {
        ...state,
        isMoving: false,
        headers: null,
        error: action.payload
      }

    case ASSET_EXPLORE_CHECK_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: r._id === action.payload._id ? r.isCheckMultiple = true : r.isCheckMultiple
          }
        })]
      }

    case ASSET_EXPLORE_UNCHECK_SELECT:
      return {
        ...state,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: r._id === action.payload._id ? r.isCheckMultiple = false : r.isCheckMultiple
          }
        })]
      }

    case MULTIPLE_EXPLORE_OPTIONS_ACTIVATE:
      return {
        ...state,
        activateMultiOptions: true
      }
    case MULTIPLE_EXPLORE_OPTIONS_DEACTIVATE:
      return {
        ...state,
        activateMultiOptions: false
      }

    case MULTIPLE_EXPLORE_OPTIONS_DONE:
      return {
        ...state,
        activateMultiOptions: false,
        data: [...state.data.map(r => {
          return {
            ...r,
            isCheckMultiple: false
          }
        })]
      }

    case ASSET_EXPLORE_UPDATE_FROM_PERMISSION:
      return {
        ...state,
        data: [
          ...state.data.map(r => {
            return r._id === action.payload._id
              ? action.payload
              : { ...r }
          })
        ]
      }
    case ASSETS_EXPLORE_MULTI_DELETE:
      return {
        ...state,
        isFetching: true
      }

    case ASSETS_EXPLORE_MULTI_DELETE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        workclient: action.payload.workclient,
        data: [...state.data.filter(r => !action.payload.ids.includes(r._id))],
        error: null
      }

    case ASSETS_EXPLORE_MULTI_DELETE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload.error
      }
    case ASSETS_EXPLORE_MULTI_MOVE:
      return {
        ...state,
        isMoving: true,
        headers: null,
        error: null
      }

    case ASSETS_EXPLORE_MULTI_MOVE_SUCCESS:
      return {
        ...state,
        isMoving: false,
        headers: action.payload.headers,
        data: [...state.data.map(r => {
          return {
            ...r,
            isMoveSelected: false,
            isMoved: action.payload.ids.includes(r._id),
          }
        })]
      }

    case ASSETS_EXPLORE_MULTI_MOVE_FAILURE:
      return {
        ...state,
        isMoving: false,
        headers: null,
        error: action.payload
      }
    case CLEAN_DATA_BACK_EXPLORE:
      return {
        ...state,
        data: [],
        showScrolling: false,
        pageScrolling: 1
      }
    case SCROLL_EXPLORE:
      return {
        ...state,
        showScrolling: action.payload.showScrolling,
        pageScrolling: action.payload.pageScrolling,
      }
    default: return { ...state }

  }

}
